/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Today_Empty_BodyInputs */

const en_us2_plan_build_today_empty_body = /** @type {(inputs: Plan_Build_Today_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build your workouts your way, with your trainer's help whenever you want.`)
};

const pt_br2_plan_build_today_empty_body = /** @type {(inputs: Plan_Build_Today_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monte seus treinos do seu jeito, com a ajuda do personal quando quiser.`)
};

const es_419_plan_build_today_empty_body = /** @type {(inputs: Plan_Build_Today_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arma tus entrenamientos a tu manera, con ayuda de tu entrenador cuando quieras.`)
};

const pt_pt2_plan_build_today_empty_body = /** @type {(inputs: Plan_Build_Today_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monta os teus treinos à tua maneira, com a ajuda do treinador quando quiseres.`)
};

const fr_fr2_plan_build_today_empty_body = /** @type {(inputs: Plan_Build_Today_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Construis tes séances à ta façon, avec l'aide de ton coach quand tu veux.`)
};

const de_de2_plan_build_today_empty_body = /** @type {(inputs: Plan_Build_Today_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bau deine Trainings nach deinen Wünschen, mit Hilfe deines Coachs, wann immer du willst.`)
};

const it_it2_plan_build_today_empty_body = /** @type {(inputs: Plan_Build_Today_Empty_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea i tuoi allenamenti a modo tuo, con l'aiuto del coach quando vuoi.`)
};

/**
* | output |
* | --- |
* | "Build your workouts your way, with your trainer's help whenever you want." |
*
* @param {Plan_Build_Today_Empty_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_today_empty_body = /** @type {((inputs?: Plan_Build_Today_Empty_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Today_Empty_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_today_empty_body(inputs)
	if (locale === "es-419") return es_419_plan_build_today_empty_body(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_today_empty_body(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_today_empty_body(inputs)
	if (locale === "de-DE") return de_de2_plan_build_today_empty_body(inputs)
	if (locale === "it-IT") return it_it2_plan_build_today_empty_body(inputs)
	return en_us2_plan_build_today_empty_body(inputs)
});
export { plan_build_today_empty_body as "plan-build.today_empty_body" }